import { FormGroup } from '@angular/forms';
import { CommonField, createFieldBase, FieldBase, FieldBaseArguments } from './FieldBase';

export function createTextboxField({
  value,
  useGrouping,
  usePercentageSuffix,
  prefixFromFields,
  fractionalLength,
  ...options
}: TextboxFieldArguments): TextboxField {
  const fieldBase = createFieldBase(options);

  let self: TextboxField = {
    ...fieldBase,
    value,
    componentType: 'textbox',
    prefixFromFields
  };

  if (fieldBase.dataType === 'number') {
    let numberFormatter = makeNumberFormatter(useGrouping, fractionalLength);
    self = {
      ...self,
      formatOnInit: numberFormatter,
      formatOnBlur: numberFormatter, // invoked every time input field loses focus
      dtoTransform: formatStringToNumber,
      usePercentageSuffix
    };
  }

  if (self.formatOnInit) {
    self.value = self.formatOnInit(self.value);
  }

  return self;
}

function makeNumberFormatter(useGrouping = false, precision = 0) {
  return function insertSeparators(value: string) {
    try {
      return formatStringToNumber(value).toLocaleString('fullwide', {
        useGrouping,
        minimumFractionDigits: precision,
        maximumFractionDigits: precision,
      });
    } catch (err) {
      return null;
    }
  };
}

function formatStringToNumber(value: string | number): number {
  if (typeof value === 'string') {
    let cleanString = value.trim();

    // Replace only the *last* comma with a dot (decimal separator)
    if (cleanString.includes(',')) {
      const lastComma = cleanString.lastIndexOf(',');
      cleanString =
        cleanString.slice(0, lastComma).replace(/,/g, '') +
        '.' +
        cleanString.slice(lastComma + 1);
    }

    // Remove spaces/grouping characters
    cleanString = cleanString.replace(/\s/g, '');

    value = Number(cleanString);
  }

  return typeof value === 'number' && !isNaN(value) ? value : null;
}


// TYPES:
export interface TextboxFieldArguments extends FieldBaseArguments {
  value?: string | number | boolean;
  fractionalLength?: number;
  useGrouping?: boolean;
  prefixFromFields?: string[];
  usePercentageSuffix?: boolean;
}

export interface TextboxField extends FieldBase {
  componentType: string;
  value?: string | number | boolean;
  formatOnInit?: Function;
  formatOnBlur?: Function;
  dtoTransform?: Function;
  prefixFromFields?: string[];
  usePercentageSuffix?: boolean;
}



// WEBPACK FOOTER //
// ./app/insa-components/insa-generic-form/generic-editor/models/Field/TextboxField.ts